/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LoginRequestDto } from '../models/LoginRequestDto';
import type { LoginResponseDto } from '../models/LoginResponseDto';
import type { MeResponseDto } from '../models/MeResponseDto';
import type { UpdateMeRequestDto } from '../models/UpdateMeRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * User login
     * @returns LoginResponseDto Logged in
     * @throws ApiError
     */
    public static loginControllerLogin({
        requestBody,
    }: {
        requestBody: LoginRequestDto,
    }): CancelablePromise<LoginResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/login',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * User logout
     * @returns void
     * @throws ApiError
     */
    public static logoutControllerLogout(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/logout',
        });
    }
    /**
     * Get current authenticated user
     * @returns MeResponseDto Current user details
     * @throws ApiError
     */
    public static meControllerGetCurrentUser(): CancelablePromise<MeResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/auth/me',
            errors: {
                401: `Not authenticated`,
            },
        });
    }
    /**
     * Update current authenticated user
     * @returns any Current user update profile
     * @throws ApiError
     */
    public static meControllerUpdateCurrentUser({
        requestBody,
    }: {
        requestBody: UpdateMeRequestDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/auth/me',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Not authenticated`,
            },
        });
    }
}
